import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { createOrder } from "../../api/apiOrders";
import parseError from "../../utils/parseError";

export const useCreateOrder = () => {
    const queryClient = useQueryClient();

    const { mutate: createOrderMutate, isPending: isCreating } = useMutation({
        mutationFn: createOrder,
        onSuccess: (res) => {
            toast.success(res.message || "Order created successfully");
            queryClient.invalidateQueries(["orders"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to create order");
        },
    });

    return { createOrderMutate, isCreating };
};
